import React from 'react'
import CustomModal from 'components/CustomModal/CustomModal'
import SelectTeamOwner from 'Manage/components/AddTeamMembersModal/components/SelectTeamOwner'

const SelectTeamOwnerModal = ({ show, teamOwners, onHide, onSuccess }) => {
  return (
    <CustomModal aria-labelledby="select-team-owner-modal" show={show} onHide={onHide} enforceFocus={false} centered>
      <SelectTeamOwner teamOwners={teamOwners} onHide={onHide} onSuccess={onSuccess} />
    </CustomModal>
  )
}

export default SelectTeamOwnerModal
